import React from "react";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import classNames from "./classNames";

const Breadcrumbs = ({ items = [], className }) => {
  if (!items.length) return null;

  return (
    <nav className={classNames("breadcrumbs", className)} aria-label="Breadcrumb">
      <ol className="breadcrumbs__list">
        {items.map((item, index) => {
          const isCurrent = index === items.length - 1;
          return (
            <li className="breadcrumbs__item" key={`${item.href || "current"}-${item.label}`}>
              {index > 0 && <FiChevronRight className="breadcrumbs__separator" aria-hidden="true" />}
              {isCurrent || !item.href ? (
                <span aria-current={isCurrent ? "page" : undefined}>{item.label}</span>
              ) : (
                <Link to={item.href}>{item.label}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
